import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row mb-2 mt-2" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attachment_uploader = _resolveComponent("attachment-uploader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_attachment_uploader, {
      modelValue: _ctx.item.image,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.image) = $event)),
      canUpload: true,
      label: "Immagine"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label small" }, "Larghezza (px)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          min: "1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.width) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.item.width,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label small" }, "Altezza (px)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          min: "1",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.height) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.item.height,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    (_ctx.item.image && _ctx.item.image.publicUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary w-100 mb-1",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fitToImageSize && _ctx.fitToImageSize(...args)))
          }, " Adatta alle dimensioni originali "),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary w-100",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fitToProportions && _ctx.fitToProportions(...args)))
          }, " Adatta mantenendo proporzioni ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label small" }, "Adattamento", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-select form-select-sm",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.objectFit) = $event))
      }, _cache[8] || (_cache[8] = [
        _createElementVNode("option", { value: "contain" }, "Contain", -1),
        _createElementVNode("option", { value: "cover" }, "Cover", -1),
        _createElementVNode("option", { value: "fill" }, "Fill", -1),
        _createElementVNode("option", { value: "scale-down" }, "Scale Down", -1)
      ]), 512), [
        [_vModelSelect, _ctx.item.objectFit]
      ])
    ])
  ]))
}